/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */
// document.addEventListener("DOMContentLoaded", function () {
// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

let spImgList = [
  'https://cdn.shoplazza.com/e3d15c5e931428f51aeb33ff55244505.png',
  'https://cdn.shoplazza.com/1beafe5598d815c3a3e930256e9380c2.png',
  'https://cdn.shoplazza.com/d4238ccc5b8e0cf806d449d403819382.png',
  'https://cdn.shoplazza.com/e49a3845abf2bd4faef915ad2666e5ad.png',

  'https://cdn.shoplazza.com/398cbc4d580be81395013543971f29d6.png',
  'https://cdn.shoplazza.com/5d67e502cca546b9f52777f125615e3a.png',
  'https://cdn.shoplazza.com/e7230a8f99f0fcf0af3c16230a89f8eb.png',
  'https://cdn.shoplazza.com/b7fa363a72176c632ab471a522082ca7.png',
  'https://cdn.shoplazza.com/07829e93f3871314b0c08ac90f7b0daa.png',
  'https://cdn.shoplazza.com/ff2e060ebe9adcdbcad63fb49527f8ea.png',

  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/202507222-c1.png',
  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/202507222-c2.png',
  'https://cdn.shoplazza.com/9ecf557be0367e746bbb72dbaf9f7b60.png',
  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/202507222-d1.png',
  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/202507222-d2.png',
  'https://cdn.shopify.com/s/files/1/0567/3520/3402/files/202507222-d3.png',
]
new Swiper('.sp-swiper1', {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    delay: 8000,
  },
  slidesPerView: 1,
  loop: false,
})
new Swiper('.sp-swiper-btn', {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
    reverseDirection: true,
    delay: 4000,
  },
  slidesPerView: 1,

  loop: true,
})
new Swiper('.sp-swiper0', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  speed: 8000,
  autoplay: true,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
  loop: true,
})
new Swiper('.sp-swiper2', {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 0,
  slidesPerView: 'auto',
  centeredSlides: true,
  loop: true,
  pagination: {
    el: '.sp-pagination1',
    clickable: true,
  },
})

new Swiper('.sp-swiper3', {
  autoplay: true,
  autoplay: {
    disableOnInteraction: false,
  },
  spaceBetween: 0,
  slidesPerView: 'auto',
  centeredSlides: true,
  loop: true,
  pagination: {
    el: '.sp-pagination3',
    clickable: true,
  },
})
let _swiper = new Swiper('.sp-swiper4', {
  slidesPerView: 1,
})
function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  lazyLoadImages()

  preloadImages(spImgList)

  // 找到所有跳转套餐的锚点链接
  var links = document.querySelectorAll('a[href^="#shopping"]')
  links.forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault() // 阻止默认的跳转行为
      // var targetElement = document.getElementById('shopping');
      // if (targetElement) {
      //     targetElement.scrollIntoView({ behavior: 'smooth' });
      // } // 方式一
      const targetElement = document.getElementById('shopping') // 获取跳转目标节点
      const offsetTop = targetElement.offsetTop
      let _topHeight = $('.time-part').height() + $('.sp-header-top').height()
      window.scroll({
        top:
          offsetTop * $('div#root').css('zoom') -
          _topHeight * $('div#root').css('zoom') +
          10,
        behavior: 'smooth', // 使用 smooth 实现平滑滚动
      }) // 方式二
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
let prods = window.product
function getCur() {
  const color = $('#sp-color .active').attr('data-val')
  const size = $('#sp-size .active').attr('data-val')
  return prods.filter(item => item.option1 == color && item.option2 == size)[0]
}
function changePrice(cur = {}) {
  console.log(cur)
  let num = $('#calcNumber').val()
  let curPrice = cur?.price || 0
  let curCompare = cur?.compare_at_price || 0
  let price = (getCur().price / 100 * num + curPrice ).toFixed(2)
  let compare = (getCur().compare_at_price / 100 * num + curCompare).toFixed(2)

  $('#sp_price1').html(price)
  $('#sp_price2').html(compare)
  let off_font =
    100 - Math.ceil((getCur().price / getCur().compare_at_price ) * 100)
  $('.product-part .price-group .sp-row span').html(`${off_font}`)
}

function calcTotal(price, num) {
  let result = Number(price) * Number(num)
  return result.toFixed(2)
}

$('.sp-reduce').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) - 1
  if (num > 0) {
    input.value = num
  }
  changePrice()
})
$('.sp-add').click(function () {
  let input = $(this).siblings('input')[0]
  let num = Number(input.value) + 1
  input.value = num
  changePrice()
})

$('.sp-option').click(function () {
  const hasActiveClass = $('#add-prod').hasClass('active')
  const isAddProd = $(this).attr('id') === 'add-prod'
  if (isAddProd && hasActiveClass) {
    $(this).removeClass('active')
  } else if (isAddProd) {
    $(this).addClass('active')
  } else {
    $(this).siblings().removeClass('active')
    $(this).addClass('active')
  }

  let colorOptions = $('#sp-color .sp-option.active').index()
  let sizeOptions = $('#sp-size .sp-option.active').index()

  let _index = colorOptions

  // $(".product-part .sp-img-p")[0].src = spImgList[_index];

  if ($('#add-prod').hasClass('active')) {
    let id = $('#add-prod').data('val')
    const cur = prods.find(item => item.id == id)
    changePrice(cur)
  } else {
    changePrice()
  }
  _swiper.slideTo(sizeOptions)
})

$(function () {
  if (window.cartCount) {
    $('#cardNum').removeClass('sp-gray')
  }
  $('.sp-btn-style').click(function () {
     let num = $('#calcNumber').val()
     window.location.href = '/cart/' + getCur().id + ':' + num
  })
  // 购物车加购动效
  $('.cart-btn').click(function () {
    $(this).children('img').addClass('on')
    $('.sp-header-top .sp-cart .num').show()
    setTimeout(function () {
      $('.cart-btn').children('img').removeClass('on')
    }, 500)
    $('.sp-header-top .sp-cart').addClass('on')
    setTimeout(function () {
      $('.sp-header-top .sp-cart').removeClass('on')
    }, 500)
  })

  // let initNum = 0;
  $('.product-part .cart-btn').click(function () {
     var data = {
       id: getCur().id,
       quantity: $('#calcNumber').val(),
     };
    // $.post(
    //   '/api/cart',
    //   {
    //     product_id: getCur().product_id,
    //     variant_id: getCur().id,
    //     quantity: $('#calcNumber').val(),
    //   },
    //   function (res) {
    //     $.get('/api/cart', function (res) {
    //       $('.sp-cart .num').html(res.cart.item_count)
    //     })
    //   }
    // )
     $.ajax({
       type: "POST",
       url: "/cart/add.js",
       data: data,
       success: function () {
         $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
           $("#cardNum").html(result.item_count);
            $("#cardNum").removeClass("sp-gray");
         });
       },
       dataType: "json",
     });

    var img = $('.product-part .sp-img-p')
    // var img = $(".product-part .sp-swiper .swiper-slide-active .sp-img");

    var flyer = img[0].cloneNode(true)
    flyer.classList.add('sp_clone')

    $('.product-part').append(flyer)
    $('.sp_clone').css({
      width: img[0].width,
      height: img[0].height,
      background: '#e7e9ef',
      position: 'fixed',
      top: img[0].offsetTop,
      left: img.offset().left,
      'z-index': '99',
    })

    let finish = $('.sp-cart')
    $('.sp_clone').animate(
      {
        top: finish[0].offsetTop,
        // top: finish[0].offsetTop + $(".time-part").height(),
        left: finish[0].offsetLeft + finish.width() / 2,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      'linear',
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach()
          }
        )
      }
    )
  })
})

// 标题文本渐出
const graduallyList = document.getElementsByClassName('gradually')
for (let gradually of graduallyList) {
  const spans = gradually.querySelectorAll('span')
  const paragraph = gradually.querySelector('.sp-sub-title')

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 给每个 span 和 i 动画
          spans.forEach((span, index) => {
            span.style.animation = `swift-up-fade 0.5s ease forwards`
            span.style.animationDelay = `${index * 0.1}s`

            const i = span.querySelector('i')
            if (i) {
              console.log(222)
              i.style.animation = `swift-up-fade 0.5s ease forwards`
              i.style.animationDelay = `${index * 0.1}s`
            }
          })

          // 段落
          const totalDelay = spans.length * 0.1 + 0.3
          if (paragraph) {
            paragraph.style.animation = `swift-up-fade 0.5s ease forwards`
            paragraph.style.animationDelay = `${totalDelay}s`
          }

          observer.unobserve(gradually)
        }
      })
    },
    {
      threshold: 0.3,
    }
  )
  observer.observe(gradually)
}
// });
